import { useDispatch } from "react-redux";
import { MediaStore } from "../../store";

export const useGetMediaCategories = () => {
  const dispatch = useDispatch();
  return (tag: boolean) => dispatch(MediaStore.Actions.getMediaCategories(tag));
};
